import script from "./TemplateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplateModal.vue?vue&type=script&setup=true&lang=js"

import "./TemplateModal.vue?vue&type=style&index=0&id=5a62e6e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a62e6e2"]])

export default __exports__